import TinyButton from "components/atoms/buttons/TinyButton";
import SearchInput from "components/atoms/input/search/SearchInput";
import { Text, UnderlineText } from "components/atoms/text/Text";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { COLORS } from "styles/colors";
import * as s from "../FilterStyled";
import { RecorderFilterTable } from "./RecorderFilterTable";
import {
  DashboardFilterRecorderData,
  DashboardFilterRecorderResult,
  DashboardFilterSearchRecordersRequest,
} from "api/interfaces/dashboardInterface.interface";
import { MapFilter, setRecorders } from "redux/reducers/map/mapFilter";
import { useQuery } from "react-query";
import { postFilterSearchRecorders } from "api/dashboardAPI";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useQueryClient } from "react-query";
import { convertType } from "utils/functions";
import useStompDebouncedRefetch, {
  StompDateSignalKey,
} from "hook/useStompDebouncedRefetch";
type Props = {
  isOpen: boolean;
  type: "recorder" | "group";
  onApply: () => void;
  onChangeFiltering: (name: string, value: boolean) => void;
  onChangeFilterName: (changeFilterName: string) => void;
};

const searchRecorderPayload = {
  keyword: {
    type: "",
    keyword: "",
  },
  accounts: [],
  recorders: [],
};

const RecorderFilter = (props: Props): JSX.Element => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const filter: MapFilter = useAppSelector((state) => state.mapFilter);

  // const [currentMenu, setCurrentMenu] = useState<number>(0);
  const [searchInput, setSearchInput] = useState<string>("");

  const [recorderData, setRecorderData] = useState<
    DashboardFilterRecorderData[]
  >([]);

  const [recorderRowSelection, setRecorderRowSelection] = useState<React.Key[]>(
    []
  );

  const getRecorders = useQuery(
    ["dashboard_recorder", selectedAccount.accountId, props.isOpen],
    () =>
      postFilterSearchRecorders({
        accountId: selectedAccount.accountId,
        payload:
          searchRecorderPayload as unknown as DashboardFilterSearchRecordersRequest,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,

      onSuccess: (res: any) => {
        if (res.error === 0 && res.result !== undefined) {
          setRecorderData(
            res.result.map((r: DashboardFilterRecorderResult) => {
              return {
                ...r,
                type: convertType(r),
                locationName: r.location ? r.location.location : "",
              };
            })
          );
        }
      },
      onError: (e: any) => {},
    }
  );
  useStompDebouncedRefetch({
    stompKey: ["recorderListUpdated"] as StompDateSignalKey[],
    refetch: getRecorders.refetch,
  });

  const onApply = () => {
    // let tempArr: string[] = [];

    // if (props.type === "recorder") {
    //   // console.log(recorderRowSelection);
    //   // recorderId 로 변경해야함
    //   tempArr = recorderRowSelection.map((r) => r.recorderId);
    //   dispatch(setRecorders(tempArr));
    // } else {
    //   recorderGroupRowSelection.length !== 0 &&
    //     recorderGroupRowSelection.map((r) => {
    //       tempArr.push(`accountId:${r.accountId}`);
    //       tempArr.push(
    //         `accountId:${r.accountId}>recorderGroupId:${r.recorderGroupId}`
    //       );
    //       if (r.recorderId) tempArr.push(r.recorderId);
    //     });
    // }
    // console.log(tempArr);
    props.onApply();
  };
  const onChangeSearch = (e: any) => {
    setSearchInput(e);
  };

  const onResetFilter = () => {
    setSearchInput("");
    queryClient.invalidateQueries("searchMapFilterResult");
    setRecorderRowSelection([]);
  };

  useEffect(() => {
    setSearchInput("");
    setRecorderRowSelection([]);
  }, [filter.keyword]);

  useEffect(() => {
    setRecorderRowSelection([]);
  }, [recorderData]);

  useEffect(() => {
    let isFilter = recorderRowSelection.length === 0;

    if (isFilter) {
      dispatch(setRecorders([]));
      props.onChangeFilterName("Recorder");
    } else {
      dispatch(setRecorders(recorderRowSelection as string[]));
      if (recorderRowSelection.length === 1) {
        let filterName = recorderData.find(
          (rec) => rec.recorderId === recorderRowSelection[0]
        )?.name;
        props.onChangeFilterName(filterName ? filterName : "Recorder");
      } else if (recorderRowSelection.length === recorderData.length) {
        props.onChangeFilterName("All Recorders");
      } else {
        props.onChangeFilterName(`${recorderRowSelection.length} Recorders`);
      }
    }

    props.onChangeFiltering("recorders", !isFilter);
  }, [recorderRowSelection]);

  return (
    <s.Container>
      <s.Title>
        <Text fontSize={14} bold>
          Recorder List
        </Text>
        <SearchInput
          map
          onClickSearch={onChangeSearch}
          keyword={searchInput}
          onClear={() => onChangeSearch("")}
        />
      </s.Title>
      <s.RecorderContents>
        {props.type === "recorder" && (
          <RecorderFilterTable
            searchInput={searchInput}
            recorderData={recorderData}
            recorderRowSelection={recorderRowSelection}
            setRecorderRowSelection={setRecorderRowSelection}
          />
        )}

        {/* {props.type === "group" && (
           <RecorderGroupFilterTable
             searchInput={searchInput}
             recorderGroupData={props.recorderGroupData}
             setRecorderRowSelection={setRecorderGroupRowSelection}
           />
          )} */}
      </s.RecorderContents>
      <s.Reset>
        <UnderlineText
          color={COLORS.LIGHTGRAY}
          fontSize={12}
          onClick={onResetFilter}
          data-testid="dashboard-map-recorder-underline-text-reset-filter"
        >
          Clear
        </UnderlineText>
        <TinyButton
          label="Done"
          onClickBtn={onApply}
          data-testid="dashboard-map-recorder-tiny-button-apply"
        />
      </s.Reset>
    </s.Container>
  );
};

export default RecorderFilter;
